(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-tabs-eyevol"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.laaa-contact-tabs').forEach(function(tabsContainer) {
      var tabs = tabsContainer.querySelectorAll('.laaa-contact-tabs__tab');
      var panels = tabsContainer.querySelectorAll('.laaa-contact-tabs__panel');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var targetTab = this.getAttribute('data-tab');

          tabs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

          panels.forEach(function(panel) {
            panel.classList.remove('is-active');
          });

          var targetPanel = tabsContainer.querySelector('#panel-' + targetTab + '-' + tabsContainer.id.split('-').pop());
          if (targetPanel) {
            targetPanel.classList.add('is-active');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-coupon-banner-eyevol"]) return;
  try {
    
  class CouponFloatingBanner extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.getAttribute('storage-key') || 'eyevol:coupon-banner';
      this.editorMode = window.Shopify && window.Shopify.designMode;

      if (!this.editorMode && this.isDismissed()) {
        this.remove();
        return;
      }

      this.closeButton = this.querySelector('[data-coupon-close]');
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.dismiss.bind(this));
      }

      requestAnimationFrame(() => this.reveal());
    }

    isDismissed() {
      try {
        return sessionStorage.getItem(this.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    reveal() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-visible'));
    }

    dismiss() {
      try {
        sessionStorage.setItem(this.storageKey, '1');
      } catch (error) {
        /* sessionStorage unavailable */
      }
      this.classList.remove('is-visible');
      setTimeout(() => this.remove(), 300);
    }
  }

  if (!customElements.get('coupon-floating-banner')) {
    customElements.define('coupon-floating-banner', CouponFloatingBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
